import { render } from "./DTable.vue?vue&type=template&id=134b7fe4"
import script from "./DTable.vue?vue&type=script&lang=ts"
export * from "./DTable.vue?vue&type=script&lang=ts"
script.render = render

export default script